import script from "./ListProductos.vue?vue&type=script&setup=true&lang=js"
export * from "./ListProductos.vue?vue&type=script&setup=true&lang=js"

import "@/assets/plantilla/style.css?vue&type=style&index=0&id=1230efd6&scoped=true&lang=css"

import exportComponent from "/var/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1230efd6"]])

export default __exports__